module.exports = __webpack_public_path__ + "img/far_day_cyl125_axis0.2e99c52e.jpg";